export type CloseCheck = { ok: boolean; reason: string };

const ok: CloseCheck = { ok: true, reason: "" };

export function canCloseTimesheet(status: string): CloseCheck {
  if (status === "approved" || status === "rejected") return ok;
  return { ok: false, reason: "Nur genehmigte oder abgelehnte LNW können abgeschlossen werden" };
}

export function canCloseOrder(timesheets: { closed_at: string | null }[]): CloseCheck {
  const open = timesheets.filter((t) => !t.closed_at).length;
  if (open === 0) return ok;
  return { ok: false, reason: `${open} LNW noch nicht abgeschlossen` };
}

export function canCloseProject(orders: { closed_at: string | null }[]): CloseCheck {
  const open = orders.filter((o) => !o.closed_at).length;
  if (open === 0) return ok;
  return { ok: false, reason: `${open} ${open === 1 ? "Auftrag" : "Aufträge"} noch nicht abgeschlossen` };
}

/** Reopening a child requires its parent to be open. */
export function canReopen(parentClosedAt: string | null | undefined, parentLabel: string): CloseCheck {
  if (!parentClosedAt) return ok;
  return { ok: false, reason: `${parentLabel} ist abgeschlossen, bitte zuerst wieder öffnen` };
}

export const dbErrorMessage = (err: { message?: string } | null, fallback: string) =>
  err?.message && !/^(new row|permission)/i.test(err.message) ? err.message : fallback;

/** One Lexware invoice draft per approved, not yet linked LNW. */
export function canCreateInvoice(ts: { status: string; lexware_invoice_id: string | null }): CloseCheck {
  if (ts.status !== "approved") return { ok: false, reason: "Nur genehmigte LNW können abgerechnet werden" };
  if (ts.lexware_invoice_id) return { ok: false, reason: "Für diesen LNW existiert bereits ein Rechnungsentwurf" };
  return ok;
}

/** Invoiced LNW positions are read-only. */
export const isInvoiceLocked = (ts: { invoiced_at: string | null }) => !!ts.invoiced_at;

export const isReadyForBilling = (ts: { status: string; lexware_invoice_id: string | null; invoiced_at: string | null; closed_at: string | null }) =>
  ts.status === "approved" && !ts.invoiced_at && !ts.closed_at;

/** Invoice sent from Lexware (or marked manually), payment still pending. */
export const isInvoiced = (ts: { invoiced_at: string | null; closed_at: string | null }) =>
  !!ts.invoiced_at && !ts.closed_at;
